(function () {
  "use strict";

  angular
    .module("virtualFairs")
    .controller(
      "VirtualFairPlatformIntegrationDetailController",
      VirtualFairPlatformIntegrationDetailController
    );

  VirtualFairPlatformIntegrationDetailController.$inject = [
    "$uibModalInstance",
    "item",
    "error",
  ];

  function VirtualFairPlatformIntegrationDetailController(
    $uibModalInstance,
    item,
    error
  ) {
    var vm = this;
    vm.ok = ok;
    vm.cancel = cancel;

    vm.item = item;
    vm.error = error;

    activate();

    function activate() {}

    function ok() {
      $uibModalInstance.close();
    }

    function cancel() {
      $uibModalInstance.close();
    }
  }
})();
